/**
 * Tres Commas queue: rotation notice.
 * For Media Devoted | Created By Ciro Autiero
 */

import { matchTracker, type TrackerId, type RotationPreviewResult } from '@trafficpulse/shared';
import { getApiErrorMessage } from '@/lib/api-error';
import type { useToast } from '@/providers/ToastProvider';
import { applyHeldReason } from '@/features/flow-optimizer/apply-report';

type Toast = ReturnType<typeof useToast>;
export function queueHeldError(provider: TrackerId, error: unknown): string | null {
  const status = (error as { response?: { status?: number } })?.response?.status;
  return matchTracker(provider, { voluum: () => null, binom: () => null,
    'tres-commas': () => status === 409 ? getApiErrorMessage(error).replace(/^Nothing pushed:\s*/i, '') : null });
}
export function announceRotation(toast: Toast, result: RotationPreviewResult, provider: TrackerId) {
  const held = result.appliedAt && !result.error ? null : applyHeldReason(provider, result);
  if (held) toast.warning('Nothing pushed', held);
  else toast.success(result.applied ? 'Rotation applied' : 'Rotation applied (local only)');
}
export function announceRotationError(toast: Toast, error: unknown, provider: TrackerId) {
  const held = queueHeldError(provider, error);
  if (held) toast.warning('Nothing pushed', held);
  else toast.error('Apply failed', getApiErrorMessage(error));
}
